import { render } from "./the-statistic-ebook.vue?vue&type=template&id=785dc7e9&ts=true"
import script from "./the-statistic-ebook.vue?vue&type=script&lang=ts"
export * from "./the-statistic-ebook.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__